import { AppLoginModule } from './../app-login/app-login.module';
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { loginRouting, loginRoutingProviders } from './login.routes';
import { SharedModule } from "../../shared/shared.module";
// import { TranslateModule } from '@ngx-translate/core';

import { LoginSelectionComponent } from './components/login-selection.component';
import { RedirectComponent } from './components/redirect.component';
import { LandingComponent } from './components/landing.component';
import { MainComponent } from './components/main.component';
import { PaperSetsModule } from '../paper-sets/paper-sets.module';

import { NgxCarouselModule } from 'ngx-carousel';
import { SubscriptionPackagesModule } from '../subscription-packages/subscription-packages.module';
import { StripHtmlPipe } from '../../stripHtml';
import { PipeTransformPipe } from '../../shared';

@NgModule({
  declarations: [
    MainComponent,
    LoginSelectionComponent,
    RedirectComponent,
    LandingComponent,
    StripHtmlPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    loginRouting,
    SharedModule,
    AppLoginModule,
    PaperSetsModule,
    SubscriptionPackagesModule,
    NgxCarouselModule
  ],
  providers: [loginRoutingProviders, StripHtmlPipe, PipeTransformPipe],
  exports: [StripHtmlPipe]

})
export class LoginModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/login.module.ts